import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import ErrorComponent from './ErrorComponent'

const ErrorConfirmation = ({
  onBack,
  onBackButtonMessage,
  onTryAgain,
  onTryAgainButtonMessage,
  error,
  subMessage
}: any) => {
  const actions = []
  if (onBack) {
    actions.push({ actionMessage: onBackButtonMessage, onAction: onBack })
  }
  if (onTryAgain) {
    actions.push({ actionMessage: onTryAgainButtonMessage, onAction: onTryAgain })
  }

  return (
    <ErrorComponent
      errors={[{ detailCode: 'ERC', actions, message: error, subMessage: subMessage, useDefaults: false }]}
    />
  )
}

ErrorConfirmation.displayName = 'ErrorConfirmation'

ErrorConfirmation.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onBack: PropTypes.func,
  onBackButtonMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onTryAgain: PropTypes.func,
  onTryAgainButtonMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  subMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
}

ErrorConfirmation.defaultProps = {
  error: <FormattedMessage id="UnrecoverableError.Title" defaultMessage="Something went wrong..." />,
  onBack: null,
  onBackButtonMessage: <FormattedMessage id="Back" defaultMessage="Back" />,
  onTryAgain: null,
  onTryAgainButtonMessage: <FormattedMessage id="TryAgain" defaultMessage="Try Again" />,
  subMessage: ''
}

export default ErrorConfirmation
